import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectableItem from '../../components/SelectableItem/SelectableItem';
import useInstallmentDecorator from './useInstallmentDecorator';
import InstallmentOptionList from './InstallmentOptionList';

function InstallmentPanel({ installments }: InstallmentPanelProps) {
  const { decorate } = useInstallmentDecorator();
  const [showInstallmentList, setShowInstallmentList] = useState(false);
  const [currentInstallmentIndex, setCurrentInstallmentIndex] = useState(0);
  const { t } = useTranslation();

  return (
    <>
      <SelectableItem
        data-testid="currentInstallmentOption"
        icon="transferReal"
        title={
          installments.length > 0
            ? decorate(installments[currentInstallmentIndex]).name
            : t('noInstallment')
        }
        onClick={() => setShowInstallmentList(true)}
        disabled={installments.length === 0}
      />

      <InstallmentOptionList
        installments={installments}
        onClose={() => setShowInstallmentList(false)}
        onSelect={setCurrentInstallmentIndex}
        show={showInstallmentList}
        currentSelectedIndex={currentInstallmentIndex}
      />
    </>
  );
}

export default InstallmentPanel;
